<!--
Author: tianyi
Date: 2019-10-23
Desc: 用户信息展示组件，由index.js 配置引入
-->
<template>
    <div :class="'view-modify-info view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <user-info />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userInfo from "@/components/acctInfo/orgInfo";
export default {
    name: "ModifyInfo",
    components: {
        userInfo
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    methods: {
    }
};
</script>
